import { useTheme } from '@/components/ThemeProvider';
import { formatBalanceWithCommas, formatDate, formatTextEllipsis, formatValueWithCompactNumber } from '@/lib/format';
import { cn } from '@/lib/utils';
import { Link } from '@/widget/Icon';
import TokenAvatar from '@/widget/TokenAvatar';
import BigNumber from 'bignumber.js';
import { useTranslation } from 'react-i18next';
import { ITransferData } from '@/page/account/hooks/useTransferHistoryList';
import { useAppStore } from '@/store';

interface IProps {
  data: ITransferData[];
  date: string;
}
export default (props: IProps) => {
  const { data, date } = props;
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { fwClass } = useAppStore();

  const viewHx = (hash: string) => {
    window.open('https://solscan.io/tx/' + hash);
  };

  return (
    <div className="pt-[12px]">
      <div className="text-secondaryTextColor text-[12px]">{formatDate(date, 'date')}</div>
      <div className="border-b-[1px] border-borderColor">
        {data.map((item, index) => {
          const amount = BigNumber(item.amount)
            .div(10 ** item.token_decimals)
            .toString();
          const state = item.flow == 'out';
          return (
            <div key={index} className="py-[12px] flex justify-between">
              <div className="flex items-center gap-x-[6px]">
                <TokenAvatar logo={item.token_icon} address={item.token_address} />
                <div>
                  <div className="flex items-center gap-x-[8px]">
                    <span>{state ? t('Account.withdraw') : t('Account.deposit')}</span>
                    <Link theme={theme} className="w-[16px] h-[16px]" onClick={() => viewHx(item.trans_id)} />
                  </div>
                  <div className="text-secondaryTextColor text-[12px]">
                    {state ? t('Account.to') : t('Account.from')} {formatTextEllipsis(state ? item.to_address : item.from_address)}
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className={cn('text-[14px]', fwClass, state ? 'text-primaryTextColor' : 'text-buyColor')}>
                  {state ? '-' : '+'}
                  {formatValueWithCompactNumber(amount)} {item.token_symbol}
                </div>
                <div className="text-secondaryTextColor text-[12px]">{formatBalanceWithCommas(item.value)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
